import i18n from './index.js'
export default {//荷兰语
  translateText: {
    shoppingcart: "winkelwagen",
    loginorrefisterText: "Inloggen/registreren",
    logoutText: "Inloggen afmelden",
    personcenterText: "Persoonlijk centrum",
    placeholderText: "Gelieve te kiezen",
    loginText: "inloggen",
    registerText: "registratie",
    emailText: "brievenbussen",
    pwdText: "wachtwoord",
    forgetpwdText: "Wachtwoord vergeten?",
    nameText: "naam",
    surnameText: "achternaam",
    mobileText: "telefoon",
    setPwdText: "wachtwoord instellen",
    countryText: "land",
    company: "onderneming",
    birthday: "verjaardag",
    yearText: "jaar",
    mouthText: "de maand",
    dayText: "dag",
    confirmpwdText: "wachtwoord bevestigen",
    agreeText1: "ik heb gelezen en ga akkoord",
    agreeText2: "gebruiksvoorwaarden",
    agreeText3: "en",
    agreeText4: "privacy statement",
    agreeText5: "En gaat ermee akkoord dat sommige van mijn persoonlijke gegevens buiten het land worden verwerkt in overeenstemming met de privacyverklaring.",
    emailplaceholder: 'geef je e-mailadres in',
    subscribetitleText: 'abonneren op onze nieuwsbrief',
    subscribeText: 'subscribe',
    shareToText: 'aandeel',
    searchText: 'zoeken',
    subtractmoneyText: "Maximaal verminderd met 600",
    magnanimitycouponText: "Enorme coupons voor u klaar om te verzamelen",
    drawText: "onmiddellijk ophalen",
    discountText: "super multi korting",
    purchaseText: "koop nu",
    composecouponText: "gecombineerde aankoop",
    manyDiscountsText: "veel aanbiedingen",
    recommendtitleText: "aanbevolen voor u",
    hotsaleproductyitleText: "hete producten",
    guessLiketitleText: "denk dat je wilt",
    NoDataText: "Geen gegevens",
    appraiseText: "evaluatie",
    certificate: "voucher",
    collectText: "collectie",
    addCartText: "in winkelwagen",
    enterkeywordsText: "voer een sleutelwoord in",
    useNowText: "voor direct gebruik",
    vouchernoText: "vouchernoText",
    placeholderyearText: " selecteer de Jaar",
    placeholdermouthText: " selecteer de maand",
    placeholderdayText: " selecteer de dag",
    // 优惠券页面
    breadcrumbItemText1: 'ultra',
    breadcrumbItemText2: 'klasse',
    breadcrumbItemText3: 'grote',
    breadcrumbItemText4: 'gelukkig',
    breadcrumbItemText5: 'de',
    magnanimitydrawText: 'Enorme coupons voor u klaar om te verzamelen',
    availablecouponstitleText: 'Beschikbare producten in vouchers',
    drawbtnText: 'ontvangen',
    universalText: 'universeel in het algemeen',
    useText: 'gebruik',
    limitText: 'voor',
    fullText: 'vol',
    subtractText: 'min',
    // 折扣
    discountitemText1: 'Kortingen zijn constant ,',
    discountitemText2: 'Beker van oranje',
    // 组合
    commoditydiscountitemText1: 'Gecombineerde aankoop ,',
    commoditydiscountitemText2: 'Preferentiele regelingen',
    combinedpriceText: 'Combinatie prijs',
    economizeText: 'besparingen',
    buynowText: "Koop nu",
    // 产品
    ourproductsText: 'Onze producten',
    productcategoryText: 'productcategorie',
    recommendtarText: 'recommended',
    newText: 'nieuw produkt',
    salesvolumetarText: 'verkoop',
    pricetarText: 'prijs',
    // 博客
    blogmanagementText: "populaire blog",
    latestblogsText: "de nieuwste blog",
    relatedrlogsText: "verwante blog",
    priceIncreasecommentText: "Opmerkingen over prijsverhogingen",
    commentsectionTtxt: "commentaartekst",
    participatingcommentsText: "bij reacties",
    // 论坛
    postingText: "post plaatsen",
    topicsText: "onderwerp",
    replyText: "antwoord",
    viewText: "view",
    lastreplyText: "laatste antwoord",
    publishText: "publiceren",
    placeholdertypeText: "selecteer een onderwerp categorie",
    placeholdertitleText: "please enter the title",
    placeholdercontentsText: "please enter content",
    fromtopicText: "uit het onderwerp: ",
    firstfloor: "1e verdieping",
    floorText: "verdieping",
    fromText: "van：",
    postreplyText: "plaats een antwoord",
    // 个人中心 - 我的订单
    myorderText: "mijn bestelling",
    mycommentsText: "mijn commentaar",
    mycollectionText: "mijn collectie",
    couponText: "coupons",
    shippingaddressText: "Verzendadres",
    myPostText: "mijn berichten",
    personalinformationText: "persoonlijke informatie",
    editText: "bewerken",
    allordersText: "alle bestellinge",
    unpaidText: "Te betalen",
    shippedText: "Te verzenden",
    receivedText: "Te ontvangen goederen",
    evaluatedText: "Te evalueren",
    baidText: "Betaling namens",
    completedText: "Voltooid",
    productinfText: "productinformatie",
    unitpricethText: "Eenheidsprijs",
    quantitythText: "hoeveelheid",
    actualpaymentthText: "bedrag",
    transactionstatusthText: "Transactiestatus",
    operationthText: "werking",
    ordernumberText: "bestelnummer",
    orderdetailsText: "Ordergegevens",
    cancelorderText: "annulering van de bestelling",
    confirmText: "bepalen",
    cancelText: "annuleren",
    deleteordertitle: "Zeker een lopende bestelling verwijderen？",
    successfultradeText: "Succesvolle transactie",
    paymentText: "bedrag",
    confirmreceiptText: "ontvangstbevestiging",
    nncommentText: 'Er zijn nog geen reacties',
    // 个人中心 - 我的评论
    productText: "product",
    productdetailText: "beoordeling details",
    replyblogText: "replyblog：",
    //个人中心 - 收货地址
    addseliveryaddressText: "nieuw afleveradres ",
    addaddresstitleText1: "is opgeslagen",
    addaddresstitleText2: "adres, kan ook worden opgeslagen",
    addaddresstitleText3: "adres van de bar",
    defaultText: "standaard",
    consigneeText: "geadresseerde：",
    addressText: "Adres",
    fulladdressText: "volledig adres：",
    setdefaultText: "stel het standaard",
    mobilephoneText: "mobiele telefoon：",
    viewmoreText: "bekijk meer",
    replypostText: "antwoord op bericht：",
    // 个人中心 - 个人信息
    nameLabel: "naam",
    sexlabel: "geslacht",
    modifyavatarText: "wijzig je hoofd",
    sexmanText: "man",
    sexwomanText: "vrouw",
    secrecyText: "geheim",
    replaceText: "vervangen",
    saveText: "opslaan",
    oldpasswordText: "origineel wachtwoord",
    newpasswordText: "nieuw wachtwoord",
    confirmpasswordText: "wachtwoord bevestigen",
    opdpleasolderText: "please enter original password",
    newpleasolderText: "please enter new password",
    unboundText: "niet gebonden",
    bindingText: "binding",
    unbindingText: "ontbind",
    // 个人中心-个人信息
    regionText: "regio's",
    addconsigneleasolderText: "Vul de naam van de geadresseerde in",
    countrypleasolderText: "Selecteer het land",
    provinceleasolderText: "selecteer provincie",
    citypleasolderText: "selecteer stad",
    areapleasolderText: "selecteer de zone",
    fulladdressTextpleasolderText: "Vul het volledige adres in",
    addconsignephoneleasolderText: "Gelieve het mobiele nummer van de geadresseerde in te vullen",
    emailpleasolderText: "Voer uw e-mailadres in",
    phoneText: 'Mobiel nummer',
    uploadimgText: "Afbeeldingen uploaden",
    updateuserface: "Aangepaste avatar",
    uploadimgtitle1: "Afbeeldingen in JPG, jpeg, PNG worden ondersteund",
    uploadimgtitle2: "Aanbevolen grootte: 200*200 of afbeeldingen op gelijke schaal",
    updateemailText: "Wijziging van de mailbox",
    updatemobileText: "wijzig je gsm-nummer",
    dialogemailtitle: "e-mailadres",
    dialogmobiletitle: "mobiel nummer",
    dialogheadertitle: "De invoer is gekoppeld aan uw kam account",
    continueText: "vervolg",
    verificationinformation: "ControlOm verder te gaan, voer deze verificatiestap uit.Wij hebben",
    verificationinformationTitle2: "De captcha is verzonden.Vul hieronder in。",
    verificationcode: "verificatiecode",
    newtitle: "De nieuwe",
    dialognewmobiletitle: "Voer het nieuwe gsm-nummer in dat u wilt associeren.En tik op bevestig vervangen",
    confirmpbtnText: "bevestiging",
    titlecpuntryselect: "selecteer het land",
    hotcountrytitle: "populaire landen",
    aboutusText: "over ons",
    // 订单详情
    havequestionsText: "Bij twijfel ",
    preferentialText: "voorkeur",
    enquiryText: "onderzoek",
    combinationdiscountText: "combinatie aanbieding",
    introduceText: "inleiding",
    buyermycommentsText: "beoordelingen van kopers",
    starText: "sterren",
    yourmailboxText: "uw mailbox",
    placeholderquestionText: "Schrijf alsjeblieft je vraag op",
    uploadimglimtText: "Upload een JPG/GIF/PNG bestand.De afbeelding mag niet groter zijn dan 2MB.",
    submitbtnText: "Verzenden",
    // 购物车
    selectText: "selectie",
    tipscartsText: "Reeds geselecteerde producten (exclusief verzendkosten)",
    settlementText: "afwikkeling",
    selectallText: "complete selectie ",
    amountText: "bedrag",
    addtofavoritesText: "toevoegen aan favorieten",
    havecollectedText: "al favoriet ",
    tipdelecteproduct: "Zeker het huidige artikel verwijderen?",
    deleteText: "geschrapt",
    tipclearcart: "Zeker het legen van de winkelwagen?",
    clearcartText: "Het legen van de winkelwagen",
    totalText: "totaal",
    totaltipText: "Artikel (exclusief verzendkosten):",



    // pieceText:"件",
    // freightText:"运费：",
    // taxationText:"税费：",
    // fullreductionamountText:"满减金额：",
    // amountpayableText:"应付金额：",
    // confirmorderText:"确认订单",
    // paymentsucceededText:"支付成功",
    // receivinginformationText:"收货信息",
    // othershippingaddressText:"其它收货地址",
    // addshippingaddressText:"添加收货地址",
    // selectshippingaddressText:"选择收货地址",
    // selfprimingText:"自提点",
    // typeofshippingText:"运输方式",
    // inquirecostsText:"点击此处咨询运费",
    // confirmproductinformationText:"确认产品信息",
    // settlementinformationText:"结算信息",
    // clipcoupons:"使用优惠券",
    // allitemsText:"全部商品",
    // validtoText:"有效期至",
    // pieceproductTotal:"件产品 总计：",
    // placeorder:"提交订单",
    // consultText:"咨询",
    // consultationText:"请输入咨询内容",
    // sendoutText:"发 送",
    // enterproductname:"输入产品名称",
    // contentText:"内容",
    // filerestrictionsText:"请上传JPG/GIF/PNG文件。图片大小不能超过2MB。",
    // withaccountText:"输入与您的 锦格 账户相关联的电子邮箱地址",
    // pagelostText:"很抱歉，你所访问的页面已失联",
    // pagelostText1:"秒后自动跳转到上一页，如没跳转 请点击刷新按钮",
    // pagelostText2:"刷新",
    // pagelostText3:"返回首页",
    // verificationrequiredText:"需要验证",
    // continuestepemailText:"要继续，请完成此验证步骤。 我们已向 电子邮件",
    // sendcodeText:"发送了验证码。 请在下面输入。",
    // resendverificationcodeText:"重新发送验证码",
    // createnewpasswordText:"创建新密码",
    // providepasswordText:"您在每次登录时，都需要提供此密码。",
    // savechangeText:"保存更改并登录",
    // shareToText1: 'follow us  on',
    // productDetailsText:"产品细节",
    // signedforText:"已签收",
    // rejectionText:"拒收",
    // evaluated1Text:"已评价",
    // reviewedText:"待审核",
    // PaidText:"已付款",
    // subtotalText:"小计",
    // waitingforpaymentText:"等待付款",
    // automaticclosingText:"来付款，超时订单自动关闭",
    // patientText:"尊敬的客户，您的订单正在出库，请您耐心等待。",
    // consigneeinformationText:"收货人信息",
    // paymentinformationText:"付款信息",
    // paymentmethodText:"付款方式：",
    // paymenttimeText:"付款时间：",
    // fullnameText:"全名",
  }
}




// WEBPACK FOOTER //
// ./src/assets/language/local_nl.js